import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import type { Backend } from './backend/types.js';
import './styles.css';

async function start() {
  // The demo build bundles the memory backend and SMYK's content; the production build never includes them.
  const backend: Backend =
    import.meta.env.MODE === 'demo'
      ? new (await import('./backend/demo.js')).DemoBackend()
      : new (await import('./backend/http.js')).HttpBackend();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App backend={backend} />
    </StrictMode>,
  );
}

void start();
